document.addEventListener('DOMContentLoaded', function () {
  var toast = document.getElementById('toast');
  var toastTimer;

  var MAIN_IMAGE_WIDTHS = [450, 700, 900, 1200];
  var MAIN_IMAGE_SIZES = '(min-width: 900px) 46vw, 100vw';

  // Shopify's CDN resizes via a `width` query param. Strip any existing one so
  // repeated swaps don't stack parameters, then request the size we want.
  function sizedUrl(base, w) {
    var clean = String(base).replace(/([?&])width=\d+/g, '$1').replace(/&&+/g, '&').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // Set src and srcset together. Setting src alone would leave a stale srcset
  // in place and the browser would keep painting the previous variant's image.
  function setMainImage(baseSrc) {
    var img = document.getElementById('product-featured-image');
    if (!img || img.tagName !== 'IMG' || !baseSrc) return;
    img.srcset = MAIN_IMAGE_WIDTHS.map(function (w) {
      return sizedUrl(baseSrc, w) + ' ' + w + 'w';
    }).join(', ');
    img.sizes = MAIN_IMAGE_SIZES;
    img.src = sizedUrl(baseSrc, 900);
  }

  document.querySelectorAll('.product-thumbs .thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var baseSrc = thumb.getAttribute('data-base-src') || thumb.getAttribute('data-full-src');
      setMainImage(baseSrc);
      document.querySelectorAll('.product-thumbs .thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2000);
  }

  function updateCartCount(count) {
    var el = document.getElementById('cart-count');
    if (el) el.textContent = count;
  }

  // Quick-add buttons on product grid cards
  document.querySelectorAll('.quick-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-variant-id');
      var title = btn.getAttribute('data-product-title');
      if (!variantId || variantId === '') return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'ADDING…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not add to cart');
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          btn.textContent = 'ADDED ✓';
          btn.classList.add('added');
          showToast(title + ' added to your run');
          setTimeout(function () {
            btn.textContent = originalText;
            btn.classList.remove('added');
            btn.disabled = false;
          }, 1400);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
          showToast('Sold out or unavailable');
        });
    });
  });

  // Product page: variant option picker -> updates hidden select + image
  var variantsJson = document.getElementById('product-variants-json');
  if (variantsJson) {
    var variants = JSON.parse(variantsJson.textContent);
    var select = document.getElementById('variant-select');
    var addBtn = document.getElementById('add-to-cart');
    var optionBlocks = document.querySelectorAll('.option-values');

    function currentSelection() {
      var selection = [];
      optionBlocks.forEach(function (block) {
        var active = block.querySelector('.option-swatch.active');
        selection.push(active ? active.getAttribute('data-value') : null);
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    function syncUI() {
      var selection = currentSelection();
      var match = findVariant(selection);
      if (match) {
        select.value = match.id;
        if (match.available) {
          addBtn.disabled = false;
          addBtn.textContent = '+ ADD TO RUN';
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'SOLD OUT';
        }
        if (match.featured_image && match.featured_image.src) {
          setMainImage(match.featured_image.src);
        }
      }
    }

    optionBlocks.forEach(function (block) {
      block.querySelectorAll('.option-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          block.querySelectorAll('.option-swatch').forEach(function (s) { s.classList.remove('active'); });
          swatch.classList.add('active');
          syncUI();
        });
      });
    });
  }

  // Newsletter form success toast (Shopify reloads with ?customer_posted=true on success)
  if (window.location.search.indexOf('customer_posted=true') > -1) {
    showToast("You're on the manifest — welcome aboard");
  }
});
